import { FC } from 'react';
import {
  ListSubheader as MuiListSubheader,
  ListSubheaderProps as MuiListSubheaderProps,
  styled,
  Typography,
} from '@mui/material';
import classNames from 'classnames';

export type ListSubheaderProps = MuiListSubheaderProps & {
  roundedBottom?: boolean;
  roundedTop?: boolean;
  variant?: 'soft' | 'subheading';
};

const StyledListSubheader = styled(MuiListSubheader)`
  &.subheading {
    background: none;
    margin-top: ${({ theme }) => theme.spacing(-1)};
  }

  &.soft {
    background: ${({ theme }) => theme.palette.action.disabledBackground};
    line-height: 2;
    position: initial;
  }

  &.roundedTop {
    border-top-left-radius: ${({ theme }) => theme.shape.borderRadius}px;
    border-top-right-radius: ${({ theme }) => theme.shape.borderRadius}px;
  }

  &.roundedBottom {
    border-bottom-left-radius: ${({ theme }) => theme.shape.borderRadius}px;
    border-bottom-right-radius: ${({ theme }) => theme.shape.borderRadius}px;
  }
`;

export const ListSubheader: FC<ListSubheaderProps> = ({
  children,
  className,
  variant = 'subheading',
  roundedBottom,
  roundedTop,
  color = 'inherit',
  ...rest
}) => (
  <StyledListSubheader
    className={classNames(className, variant, { roundedBottom, roundedTop })}
    color={color}
    {...rest}
  >
    {variant === 'subheading' ? (
      <Typography color='text.primary' component='span' variant='h4'>
        {children}
      </Typography>
    ) : (
      children
    )}
  </StyledListSubheader>
);
